import { ISendEmailOrdemCompraUseCase } from "../../../presentation/useCases/read/send_email_ordem_compra_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * SendEmailOrdemCompraUseCase
 */

export class SendEmailOrdemCompraUseCase implements ISendEmailOrdemCompraUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async sendEmailOrdemCompra(
    idRequisicaoCompra: number,
    subject: string,
    sendTo: string,
    body: string,
    attachment: string,
  ): Promise<void> {
    const emails = sendTo.split(';');

    emails.forEach(e => e.trim());

    await this.repository.sendEmailOrdemCompra(
      idRequisicaoCompra,
      subject,
      emails,
      body,
      attachment,
    );
  }
}
